/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-26 15:27:03
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-01-30 16:17:31
 * @FilePath: /knit-web/src/locale/zh-CN/notification.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  notification: {
    invitationAccepted: '邀请已同意',
    invitationRejected: '邀请已拒绝',
    memberJoinedWorkspace: '成员加入工作空间',
    invitationDeclined: '邀请已拒绝',
    memberJoinedContent:
      '{username} 已接受邀请并加入了工作空间 {workspace_name}。他们现在可以访问工作空间资源。',
    invitationDeclinedContent:
      '{username} 已拒绝加入工作空间 {workspace_name} 的邀请。',
    viewDetails: '查看详情',
    memberLeftWorkspace: '成员离开工作空间',
    memberLeftContent:
      '{username} 已离开工作空间 {workspace_name}，不再拥有访问其资源的权限。',
    acceptInvitationTitle: '接受邀请？',
    acceptInvitationMessage:
      '您即将加入工作空间 {workspaceName}。您将获得访问其资源的权限。',
    declineInvitationTitle: '拒绝邀请？',
    declineInvitationMessage:
      '如果您拒绝，将无法访问 {workspaceName}，除非再次被邀请。',
    joinedWorkspaceTitle: '您已加入工作空间',
    joinedWorkspaceMessage: '您现在可以与团队协作并访问所有可用资源。',
    backToMessages: '返回消息',
    goToWorkspace: '前往工作空间',
    accept: '接受',
    decline: '拒绝',
    cancel: '取消',
    creditInsufficientBanResourceTitle: '数据库实例已暂停服务',
    creditInsufficientBanResourceContent:
      '您的实例 {instance_name} 因额度不足已暂停服务，请充值以恢复访问。',
    creditUnbanResourceTitle: '数据库实例已恢复',
    creditUnbanResourceContent:
      '您的实例 {instance_names} 已恢复正常运行，当前额度充足。',
    fetchListFailed: '获取通知列表失败',
    markReadFailed: '标记已读失败',
    acceptInvitationFailed: '接受邀请失败',
    declineInvitationFailed: '拒绝邀请失败',
  },
};
